var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-12 col-lg-8 col-12 mt-3"},[_c('div',{staticClass:"sumilla my-5"},[_c('div',{}),_c('div',{staticClass:"sumilla-content"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.cardText.text)}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }